<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Recharge card setup'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <span *ngIf="loadingData">
            {{'Loading'|translate}}...
        </span>
        <form name="form" [formGroup]="form" (ngSubmit)="onSubmit()" fxLayout="column"
              fxLayoutAlign="start"
              fxFlex="1 0 auto" *ngIf="!loadingData">
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Day of month'|translate}}</mat-label>
                    <input matInput formControlName="dayOfMonth" required>
                    <mat-error>{{'Day of month is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="enabled" fxFlex="25">
                    <mat-label>{{'Enabled'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div>
                <table class="table">
                    <thead *ngIf="rechargeCardSetup.items.length > 0">
                    <tr>
                        <th style="width: 80%;">{{'Service'|translate}}</th>
                        <th style="width: 10%;">{{'Quantity'|translate}}</th>
                        <th style="width: 10%;"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr formArrayName="items"
                        *ngFor="let line of items().controls; index as i">
                        <td [formGroupName]="i" style="width: 80%;">
                            <mat-form-field appearance="outline" style="width: 100%;">
                                <mat-select formControlName="service" required>
                                    <mat-option [value]="service.id"
                                                *ngFor="let service of services">
                                        {{service.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td [formGroupName]="i">
                            <mat-form-field appearance="outline" style="width: 100%;">
                                <input matInput formControlName="quantity" required>
                            </mat-form-field>
                        </td>
                        <td>
                            <button (click)="removeItem(i)" mat-raised-button
                                    color="warn">{{'Remove'|translate}}</button>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td>
                            <button type="button" (click)="addItem()" mat-raised-button
                                    color="primary">{{'Add item'|translate}}</button>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(form)"
                aria-label="Save">
            {{'Save'|translate}}
        </button>

    </div>
</div>
